import React from 'react';
import { Link } from 'react-router-dom';

function SpeakersWidget() {
  const speakers = [
    {
      name: 'David Sinclair',
      image: '/david-sinclair-headshot-2024.png',
      link: '/david-sinclair'
    },
    {
      name: 'Matthew Walker',
      image: '/assets/matthew-walker-speaker.webp',
      link: '/matthew-walker'
    },
    {
      name: 'Dr. Daniel Amen',
      image: '/assets/amen-speaker.webp',
      link: '/daniel-amen'
    },
    {
      name: 'Diana Palotas',
      image: '/assets/Diana-Palotas-card.webp',
      link: '/diana-palotas'
    }
  ];

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="speakers-sidebar-global">
        {speakers.map((speaker, index) => (
          <div key={index} className="speaker-sidebar-item">
            {speaker.link.startsWith('/') ? (
              <Link to={speaker.link} className="speaker-sidebar-circle">
                <img 
                  src={speaker.image} 
                  alt={speaker.name} 
                  loading="lazy"
                />
              </Link>
            ) : (
              <a href={speaker.link} className="speaker-sidebar-circle">
                <img 
                  src={speaker.image} 
                  alt={speaker.name} 
                  loading="lazy"
                />
              </a>
            )}
            <span className="speaker-sidebar-name">{speaker.name}</span>
          </div>
        ))}
      </div>
    </>
  );
}

export default SpeakersWidget;

